import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace SniffNGo {
  export const form: IEventRegisterRow[] = [
    {
      inputs: [{
        type: "checkbox",
        multiSelect: false,
        label: Constants.show_type.sniff_n_go,
        options: [
          { value: Constants.dog_class_element_level.one_hide_birch, id: Constants.dog_class_element_level.one_hide_birch },
          { value: Constants.dog_class_element_level.two_hides_birch_anise, id: Constants.dog_class_element_level.two_hides_birch_anise },
          { value: Constants.dog_class_element_level.three_hides_birch_anise_clove, id: Constants.dog_class_element_level.three_hides_birch_anise_clove },
          { value: Constants.dog_class_element_level.new_to_nosework, id: Constants.dog_class_element_level.new_to_nosework },
        ]
      }]
    }
  ];
}
